module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"searchPlaceholder":"Typ..."},"en":{"searchPlaceholder":"Type and choose one"},"it":{"searchPlaceholder":"Scriva e scelga uno"},"lt":{"searchPlaceholder":""},"pl":{"searchPlaceholder":""}}')
  delete Component.options._Ctor
}
